import 'chosen-js';
import { getBreakpoint, getRTL } from './_utils';

const classes = {
	dropdownFieldChanged: 'Dropdown-field--changed',
	dropdownFieldFilled: 'Dropdown-field--filled',
};

const selectors = {
	dropdownField: '.Dropdown-field',
	multiSelectField: '.useChips',
	removeAll: '.Dropdown-removeAll',
	label: '.formElement-label',
	chosenInput: '.chosen-search-input',
	chosenResults: '.chosen-results',
	selectedResults: 'li.result-selected',
};

function setupDropdowns() {
	const $dropdowns = $(selectors.dropdownField);

	$dropdowns.on('change', e => {
		$(e.target).addClass(classes.dropdownFieldChanged);
		const value = $(e.target).val();
		if (value && value.length > 0) {
			$(e.target).addClass(classes.dropdownFieldFilled);
		} else {
			$(e.target).removeClass(classes.dropdownFieldFilled);
		}
	});
}

function setupMultipleSelects() {
	const $multiSelects = $(selectors.multiSelectField);
	const breakpoint = getBreakpoint();

	$multiSelects.each(function () {
		let $select = $(this);

		//only setup chosen on desktops
		let $dropdown = $select.parent();
		if (breakpoint === 'large' || breakpoint === 'xlarge') {
			//capture chosen input losing focus
			let triggerBlur = () => {
				$select.trigger('blur');
			};
			$dropdown.on('blur', selectors.chosenInput, triggerBlur);

			//initialize chosen
			$select.chosen({ width: '100%', placeholder_text_multiple: ' ', rtl: getRTL() });

			const addCheckboxes = () => {
				$dropdown
					.find(selectors.chosenResults)
					.children('li')
					.each(function () {
						const $option = $(this);
						//pull out the text only, so check for labels too
						const $label = $option.find('label.Checkbox-label');
						$option.html(
							`<div class="Checkbox"><label class="Checkbox-decoration"></label><label class="Checkbox-label ty-b2">${
								$label.length > 0 ? $label[0].innerHTML : this.innerHTML
							}</label></div>`
						);
					});
			};

			//add checkboxes when we open the dropdown
			$select.on('chosen:showing_dropdown', addCheckboxes);
			//add checkboxes when we type in the search box
			$dropdown.find(selectors.chosenInput).on('keyup', addCheckboxes);

			//set up the remove all button
			const handleRemoveAll = () => {
				$select.find('option:selected').prop('selected', false);
				$select.trigger('chosen:updated');
				$select.removeClass(classes.dropdownFieldFilled);
				$dropdown.removeClass('noCaret showRemoveAll');
				triggerBlur();
			};

			$dropdown.find(selectors.removeAll).on('click', handleRemoveAll);
			$dropdown.find(selectors.removeAll).on('keyup', event => {
				if (event.which === 13) {
					handleRemoveAll();
				}
			});

			//watch for remove items when this field isn't in focus
			$select.on('change', (e, params) => {
				addCheckboxes();
				if (
					params &&
					params.deselected &&
					!$dropdown.find(selectors.chosenInput).is(':focus')
				) {
					triggerBlur();
				}

				//show/hide the remove button
				if ($select.val().length > 0) {
					$dropdown.addClass('noCaret showRemoveAll');
				} else {
					$dropdown.removeClass('noCaret showRemoveAll');
				}
			});

			if ($select.val().length > 0) {
				$dropdown.addClass('noCaret showRemoveAll');
			} else {
				$dropdown.removeClass('noCaret showRemoveAll');
			}
		} else {
			//remove the selected empty option
			$select.children('option:first').remove();
			$dropdown.find(selectors.label).addClass('formElement--focusAlways');
		}
	});
}

export default function init() {
	setupDropdowns();
	setupMultipleSelects();
}
